import { render, staticRenderFns } from "./datasource-physical-archive-form.vue?vue&type=template&id=3de41de0"
import script from "./datasource-physical-archive-form.vue?vue&type=script&lang=js"
export * from "./datasource-physical-archive-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports